import React, { useState } from 'react';
import axios from 'axios';
import Modal from '../ui/Modal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProfileCompletionModal = ({ user, onComplete, t }) => {
  const [formData, setFormData] = useState({
    birth_date: '',
    gender: '',
    weight: '',
    height: '',
    phone: user.phone || ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submitData = {
        ...formData,
        weight: formData.weight ? parseFloat(formData.weight) : null,
        height: formData.height ? parseFloat(formData.height) : null
      };

      await axios.put(`${API}/auth/profile`, submitData);
      alert('✅ ¡Perfil completado con éxito!');
      onComplete();
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('❌ Error al actualizar el perfil');
    }
    setLoading(false);
  };

  return (
    <Modal maxWidth="max-w-2xl" preventClose>
      <Modal.Header>
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white">👋 ¡Bienvenido/a, {user.full_name}!</h2>
          <p className="text-blue-300 text-sm mt-1">Por favor completa tu perfil para continuar</p>
        </div>
      </Modal.Header>

      <Modal.Body>
        <form id="profile-completion-form" onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-blue-300 mb-2 text-sm font-semibold">
              Fecha de nacimiento <span className="text-red-400">*</span>
            </label>
            <input
              type="date"
              value={formData.birth_date}
              onChange={(e) => setFormData({...formData, birth_date: e.target.value})}
              className="input-field w-full"
              max={new Date().toISOString().split('T')[0]}
              required
            />
          </div>

          <div>
            <label className="block text-blue-300 mb-2 text-sm font-semibold">
              Género <span className="text-red-400">*</span>
            </label>
            <select
              value={formData.gender}
              onChange={(e) => setFormData({...formData, gender: e.target.value})}
              className="input-field w-full"
              required
            >
              <option value="">Seleccionar opción</option>
              <option value="male">Masculino</option>
              <option value="female">Femenino</option>
              <option value="prefer_not_to_say">Prefiero no decirlo</option>
            </select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-blue-300 mb-2 text-sm font-semibold">
                Peso actual (kg) <span className="text-red-400">*</span>
              </label>
              <input
                type="number"
                step="0.1"
                min="20"
                max="300"
                value={formData.weight}
                onChange={(e) => setFormData({...formData, weight: e.target.value})}
                className="input-field w-full"
                placeholder="ej., 75.5"
                required
              />
            </div>

            <div>
              <label className="block text-blue-300 mb-2 text-sm font-semibold">
                Altura (cm) <span className="text-red-400">*</span>
              </label>
              <input
                type="number"
                step="0.1"
                min="100"
                max="250"
                value={formData.height}
                onChange={(e) => setFormData({...formData, height: e.target.value})}
                className="input-field w-full"
                placeholder="ej., 175"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-blue-300 mb-2 text-sm font-semibold">
              Teléfono
            </label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="input-field w-full"
              placeholder="+34 600 000 000"
            />
          </div>

          <div className="bg-blue-900/20 border border-blue-400/20 rounded-lg p-4">
            <p className="text-blue-300 text-sm">
              ℹ️ Esta información nos ayuda a personalizar tu experiencia de entrenamiento y seguimiento de progreso.
            </p>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer>
        <button
          type="submit"
          form="profile-completion-form"
          disabled={loading}
          className="btn-primary w-full py-3 text-lg"
        >
          {loading ? 'Guardando...' : '✅ Completar perfil'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProfileCompletionModal;
